import {
  BentoContact,
  EmailSequence,
  NewBentoContact,
} from "schemas/dashboard";

import { Template } from "features/Influencer/ContactList/schema";

export type BulkSendState = {
  emailSequences: EmailSequence[];
  fallbackTemplates: Template[];
};

export type EmailSequenceBe = {
  bentoBrandId: number;
  fallbackTemplateIds: number[];
  bentoContactId?: number;
  newContact?: NewBentoContact;
};

export enum DialogScreen {
  templates_and_time = "templates_and_time",
  review_brands = "review_brands",
  success = "success",
}

export type BulkSendEmailSetting = {
  templateIds: number[];
  type: "category" | "automation";
  isUncategorized?: boolean;
};

export type SelectedContactMap = Record<
  number,
  BentoContact | NewBentoContact | null
>;
